import {EditorState} from "prosemirror-state";
import {NodeType} from "prosemirror-model";

import {isNodeSelection} from "./isNodeSelection";

export const isBlockActive = (
    type: NodeType,
    attrs: Record<string, unknown> = {}
) => (state: EditorState): boolean => {
    if (isNodeSelection(state.selection)) {
        return state.selection.node.hasMarkup(type, attrs)
    }

    const { $from, to } = state.selection;

    return to <= $from.end() && $from.parent.hasMarkup(type, attrs)
}